'use client'
import { createContext, useState } from 'react'
import type { Dispatch, FC, ReactNode, SetStateAction } from 'react'

type TypeTransitionName = 'exit' | 'animate'
type TypeContext = {
  transitionName: TypeTransitionName,
  setTransitionName: Dispatch<SetStateAction<TypeTransitionName>>
  cortinaTransitionName: 'idle' | 'covering' | 'revealing' | 'done'
  setCortinaTransitionName : Dispatch<SetStateAction<'idle' | 'covering' | 'revealing' | 'done'>>
  targetHref?: string
  setTargetHref?: Dispatch<SetStateAction<string>>
  setIsLoading?: Dispatch<SetStateAction<boolean>>
  isLoading?: boolean
}

export const PageTransitionContext = createContext<TypeContext | null>(null)

interface Props {
  children: ReactNode
}

export const PageTransitionProvider:FC<Props> = ({ children }) => {
  const [transitionName, setTransitionName] = useState<TypeTransitionName>(null)
  const [cortinaTransitionName, setCortinaTransitionName] = useState<'idle' | 'covering' | 'revealing' | 'done'>('idle')
  const [targetHref, setTargetHref] = useState<string>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  
  return (
    <PageTransitionContext.Provider value={{ transitionName, setTransitionName, cortinaTransitionName, setCortinaTransitionName, targetHref, setTargetHref, isLoading, setIsLoading }}>
      {children}
    </PageTransitionContext.Provider>
  )
}
